import { Routes, Route, Navigate } from "react-router-dom";
import Layout from "@/components/Layout";
import Login from "@/pages/Login";
import Dzis from "@/pages/Dzis";
import Podsumowanie from "@/pages/Podsumowanie";
import Status from "@/pages/Status";
import Sprzedaz from "@/pages/Sprzedaz";
import Landingi from "@/pages/Landingi";
import Filmy from "@/pages/Filmy";
import Komentarze from "@/pages/Komentarze";
import KomentarzeStatystyki from "@/pages/KomentarzeStatystyki";
import SocialProof from "@/pages/SocialProof";
import HistorieMessenger from "@/pages/HistorieMessenger";
import ZespolAI from "@/pages/ZespolAI";
import Kanban from "@/pages/Kanban";
import Wysylka from "@/pages/Wysylka";
import Karuzele from "@/pages/Karuzele";
import KaruzeleUstawienia from "@/pages/KaruzeleUstawienia";
import Zdjecia from "@/pages/Zdjecia";
import Fonty from "@/pages/Fonty";
import PlanTygodnia from "@/pages/PlanTygodnia";
import TydzienArka from "@/pages/TydzienArka";
import Publikacje from "@/pages/Publikacje";
import Wiedza from "@/pages/Wiedza";
import PrzeplywWiedzy from "@/pages/PrzeplywWiedzy";
import Bart from "@/pages/Bart";
import Barometr from "@/pages/Barometr";
import OpDemo from "@/pages/OpDemo";

export default function App() {
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Layout />}>
        <Route path="/" element={<Dzis />} />
        <Route path="/podsumowanie" element={<Podsumowanie />} />
        <Route path="/status" element={<Status />} />
        <Route path="/sprzedaz" element={<Sprzedaz />} />
        <Route path="/landingi" element={<Landingi />} />
        <Route path="/filmy" element={<Filmy />} />
        <Route path="/komentarze" element={<Komentarze />} />
        <Route path="/komentarze/statystyki" element={<KomentarzeStatystyki />} />
        <Route path="/komentarze/social-proof" element={<SocialProof />} />
        <Route path="/barometr" element={<Barometr />} />
        <Route path="/historie-messenger" element={<HistorieMessenger />} />
        <Route path="/zespol-ai" element={<ZespolAI />} />
        <Route path="/kanban" element={<Kanban />} />
        <Route path="/wysylka" element={<Wysylka />} />
        <Route path="/karuzele" element={<Karuzele />} />
        <Route path="/karuzele/ustawienia" element={<KaruzeleUstawienia />} />
        <Route path="/zdjecia" element={<Zdjecia />} />
        <Route path="/fonty" element={<Fonty />} />
        <Route path="/plan-tygodnia" element={<PlanTygodnia />} />
        <Route path="/tydzien-arka" element={<TydzienArka />} />
        <Route path="/publikacje" element={<Publikacje />} />
        <Route path="/wiedza" element={<Wiedza />} />
        <Route path="/przeplyw-wiedzy" element={<PrzeplywWiedzy />} />
        <Route path="/bart" element={<Bart />} />
        <Route path="/op-demo" element={<OpDemo />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
